import {erc20ABI} from "wagmi";
import {readContract, writeContract} from "wagmi/actions";
import {arbitrum} from "viem/chains";
import proxyErc721Abi from "../abi/proxyErc721.json";

export const getAllowance = async (
  contractAddress: string,
  userAddress: string,
  spenderAddress: string,
)=> {
  return await readContract({
    address: contractAddress as `0x${string}`,
    abi: erc20ABI,
    functionName: 'allowance',
    args: [userAddress as `0x${string}`, spenderAddress as `0x${string}`],
  })
}

export const getBalance = async (
  contractAddress: string,
  userAddress: string,
)=> {
  return await readContract({
    address: contractAddress as `0x${string}`,
    abi: erc20ABI,
    functionName: 'balanceOf',
    args: [userAddress as `0x${string}`],
  })
}

export const approve = async (
  contractAddress: string,
  spenderAddress: string,
  amount: bigint
) => {
  return await writeContract({
    address: contractAddress as `0x${string}`,
    abi: erc20ABI,
    functionName: 'approve',
    args: [spenderAddress as `0x${string}`, amount],
    //chainId: arbitrum.id
  })
}

export interface BridgeFee {
  nativeFee: bigint,
  zroFee: bigint
}

export const estimateSendFee = async (
  contractAddress: string,
  chainId: number,
  address: string,
  amount: bigint,
  flag: boolean,
  adapterParams: string,
  fromChainId?: number
): Promise<BridgeFee> => {
  const [nativeFee, zroFee] = await readContract({
    address: contractAddress as `0x${string}`,
    abi: proxyErc721Abi,
    functionName: 'estimateSendFee',
    args: [chainId, address as `0x${string}`, amount, flag, adapterParams],
    chainId: fromChainId
  }) as [nativeFee: bigint, zroFee: bigint]

  return {
    nativeFee,
    zroFee
  }
}

export const sendFrom = async (
  contractAddress: string,
  params: [
    fromUserAddress: string,
    chainId: number,
    toUserAddress: string,
    amount: bigint,
    refundAddress: string,
    constantValue: string,
    adapterParams: string
  ],
  value: bigint
) => {
  return await writeContract({
    address: contractAddress as `0x${string}`,
    abi: proxyErc721Abi,
    functionName: 'sendFrom',
    args: [...params],
    value
    // chainId: arbitrum.id
  })
}
